import { darkModeAware, withStyles } from '@glu/theming';
import { objectOf, string } from 'prop-types';
import React from 'react';
import '../themeDefaults';

// istanbul ignore next
const styles = ({ formComponents }) => ({
  root: {
    ...formComponents.error,
    margin: [6, 0, 0],
    color: ({ dark, warning }) => ((dark ? formComponents.dark : formComponents)[warning ? 'warning' : 'error'].color)
  }
});

const Error = ({ classes, error }) => (error ? (
  <p className={classes.root}>{error}</p>
) : null);

Error.propTypes = {
  classes: objectOf(string).isRequired,
  error: string
};

Error.defaultProps = {
  error: ''
};

export default darkModeAware(withStyles(styles)(Error));
